import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
const icon1 = "https://winpeforum.com/assets/elements/NupurGarg.jpg";
const icon2 = "https://winpeforum.com/assets/elements/JyotsnaKrishnan.jpeg";
const icon4 = "https://winpeforum.com/assets/elements/RichaBajpai.jpg";
const icon8 = "https://winpeforum.com/assets/elements/Nruthya.png";

let duration = 400;
 

const I1 = "https://www.winpeforum.com/assets/sheshines/19june2025/15.jpg";
const I2 = "https://www.winpeforum.com/assets/sheshines/19june2025/19.jpg";
const I3 = "https://www.winpeforum.com/assets/sheshines/19june2025/17.jpg";
const I4 = "https://www.winpeforum.com/assets/sheshines/19june2025/20.jpg";
const I5 = "https://www.winpeforum.com/assets/sheshines/19june2025/13.jpg";
const I6 = "https://www.winpeforum.com/assets/sheshines/19june2025/1.jpg";
 
 

 
 

const II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/15.jpg";
const II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/19.jpg";
const II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/17.jpg";
const II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/20.jpg";
const II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/13.jpg";
const II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/1.jpg";
 
 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
     
    this.Speaker1 = [
       {
        imgUrl: icon2,
        desc: `<div>
     Jyotsna Krishnan is Managing Partner at Elevar Equity and CEO and Co-founder at EPIC World. 
 <br/><br/>
With over two decades of expertise in business and finance, Jyotsna is reshaping the way enduring companies are built to serve Entrepreneurial Households. As Managing Partner at Elevar Equity, she has built a high-performing investment practice known for spotting early opportunities, and partnering closely with entrepreneurs building transformational business models in critical sectors like agri, finance, and health. Jyotsna balances sharp commercial acumen with deep empathy, enabling her to identify and scale unique business models that drive real impact. She also leads the EPIC World team with its vision to help build and scale 50+ blue chip companies serving Entrepreneurial Households. She spends significant time in the field, gathering insights about Entrepreneurial Households—an invaluable resource for companies serving this fast rising segment.

		</div>`,
        name: "Jyotsna Krishnan",
        post: `<div>Managing Partner<br/> Elevar Equity, <br/>
CEO and Co-founder<br/> EPIC World

        </div>`,
      },
      
 {
            imgUrl: icon8,
            desc: `<div>
            Nruthya Madappa is Partner at 3one4 Capital. In addition to supporting investments, topline and capital growth for the portfolio at the firm, Nruthya works closely with global institutional and strategic investors to drive the growth of our portfolio companies. Her team partners deeply with the latter in planning and achieving financial and strategic objectives including capital raises, revenue acceleration, M&A, and exits.
            <br/><br/>
    Over her career in the US and India, Nruthya has led global teams across technology, finance, real estate, education and economic policy. Before 3one4 Capital, Nruthya founded and led The CoWrks Foundry (a business accelerator for early stage companies) as Managing Partner, investing in over 25 companies and establishing global partnerships with Yale and Columbia University.
    <br/><br/>
    Prior to The CoWrks Foundry she drove the Revenue and Growth orgs at Cuemath and spearheaded the 15M Series B from Capital G and Sequoia Capital for the edtech giant. Throughout her career, Nruthya has designed and scaled products, and raised capital for high growth companies - strengths she brings to bear for the 3one4 portfolio.
    <br/><br/>
    Nruthya holds BS and MS degrees in Electrical Engineering from Stanford University and an MBA from Harvard Business School.
    
            </div>`,
            name: "Nruthya Madappa",
            post: `<div>Partner<br/>
            3one4 Capital
     
            </div>`,
          },

       {
            imgUrl: icon1,
            desc: `<div>
          Nupur Garg is a leading investor in private equity and venture capital, and the founder of Winpe, an initiative to promote gender diversity in investing. She chairs the board of Kids Clinic India (Cloudnine Hospitals) and serves as an independent director at Edelweiss Real Assets, Kerala Infrastructure Fund Management, and Molbio Diagnostics. She is an advisor to the Dutch Good Growth Fund and has served on the boards and investment committees of SIDBI, NIIF, and the Fund of Funds for Startups.<br/><br/>

Recognized globally, Nupur has been featured in PEI’s Most Influential Women (2024) and the Forbes W-Power List (2020). She advises fund managers on governance and mentors women entrepreneurs.
<br/><br/>
A Chartered Accountant and MIT Sloan MBA, with executive education from Harvard, Nupur earlier led IFC’s South Asia PE/VC practice, delivering its first positive returns.

            </div>`,
            name: "Nupur Garg",
            post: `<div>Founder<br/>Winpe
    
    
            </div>`,
          },

      {
            imgUrl: icon4,
            desc: `<div>
          Richa is the Founder & CEO of Campus Fund - Asia's largest VC Fund investing in student-led startups in India. She was also part of the Investment Committee of Creator Fund investing in Student Led Startups in the UK,European Region.
<br/><br/>
Richa co-founded Goodera - A global technology company that helps large enterprises, measure and manage the impact of their CSR, Sustainability & Volunteering initiatives. Goodera manages more than $300m of development capital on behalf of its clients. Goodera valued at $150Mn+, since inception in 2014 has raised capital from the likes of Omidyar Network, Teneo Ventures, Elevation Capital, xto10x, Zoom Ventures, Ursula Burns amongst others.
<br/><br/>
She also spent time as an advisor at a boutique PE firm headquartered in London, called Blue Knot Partners backed by Relay Investments.
<br/><br/>
Richa has done her MBA from London Business School and has also been recognized as part of the Forbes 30u30 India (2014) & Asia (2016) list, MIT Innovators under 35 India (2016) List and Young Global Leader (2024) by World Economic Forum.

            </div>`,
            name: "Richa Bajpai",
            post: `<div>Founder<br/>Campus Fund and Goodera
    
    
            </div>`,
          },


      
    ];

    this.Speaker2 = [
       
      
      {
        imgUrl: icon2,
        desc: `Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.
<br/><br/>
At McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.


         `,
        name: "Alka Goel",
        post: `<div>Founding Partner<br/> Alkemi Growth Capital
        </div>`,
      },

      
    ];
    this.CollegiumsImages = [
      { id:23, ImgSrc: I1, ImgSrc1: II1,},   
      
        { id:35, ImgSrc: I2, ImgSrc1: II2,},   

        { id:22, ImgSrc: I3, ImgSrc1: II3,},   
        { id:19, ImgSrc: I4, ImgSrc1: II4,},  
        { id:35, ImgSrc: I5, ImgSrc1: II5,},   
        { id:34, ImgSrc: I6, ImgSrc1: II6,},  
      
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="sheshines with Winpe"
          image={"https://winpeforum.com/assets/elements/sheshineswebpage1.png"}
          description="Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! "
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left">Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">sheshines with Winpe </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                  <span>June 19, 2025 (5:00 - 8:00 PM IST)</span>
                  <br/>
                  <span> <i>Bangalore </i></span>
                </div>
              </div>
              <center><h3>Hosted By:</h3><br/>
              <img src={"https://winpeforum.com/assets/elements/epicworld-removebg-preview.png"} style={{width:'100px'}}/> <br/><br/>
           
          </center> <br/>     
              
              <div className="top_text" style={{textAlign:'justify'}}>
             Yet another engaging edition of sheshines in Bangalore on June 19, 2025, brought together founders and investors. Co-hosted by Epic World, the topic for the evening was titled <b>"The Founder–Investor Dance: Building High-Trust Relationships with the Right Capital Partner”</b> and was held at the Epic World office.<br/><br/>
The event kicked off with a lively round of Human Bingo- a fun, interactive icebreaker that sparked spontaneous conversations and shared laughter. <br/><br/>
 <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Event Highlights</h2>          <div class="r_btm"></div>

The conversation for the evening brought together some of the most respected voices in the entrepreneur and investment landscape to discuss what makes founder-investor relationships truly work- beyond the pitch and the term sheet.
<br/> <br/>

    <div className="row"> 
                          

                  <div className="col-md-12">   

                  <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Speakers</h2>          <div class="r_btm"></div>
                      
                 
                     
                      <div className="Our_Speakers container">
                                <center>
                                  <div className="Speakers_img" style={{ width: '100%', margin:'0' }}>
                                    <div className="row">
        
                                      {this.Speaker1.map((item, i) => {
                                       if(i<=3) 
                                       {
                                        return (
                                          <div
                                            className="main_speaker_card col-md-3 col-sm-12 col-lg-3"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                       }
                                       else 
                                       return (
                                          <div
                                            className="main_speaker_card col-md-3 col-sm-12 col-lg-3"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
        
                                </center>
                              </div>
        </div>
        
                
</div> 



<br/>
Moderated with nuance and depth by Nupur Garg, Founder of Winpe, the panel explored how trust is built and sustained, the importance of value alignment, and how founders can choose capital partners who support long-term vision over short-term returns.
<br/><br/>
<h4><b>Key Takeaways from the evening:</b></h4>

<ul>
<li><b>Trust, Transparency & Respect are Foundational</b> 
<br/>
A healthy founder-investor relationship is built on complete transparency, mutual trust, and respect. Investors must give founders the space to operate and trust their on-the-ground decision-making. Recognizing that great businesses are built by people of diverse personalities, ages, and genders is essential.
</li>
 <li><b>Set Expectations Early</b> 
<br/>
Misalignment often begins when roles and expectations are unclear. It’s critical to set boundaries and align on vision from the outset. Unequal treatment of co-founders and lack of faith in the founder’s vision are common sources of friction.
</li>
<li><b>Invest in the Relationship – Not Just the Company</b> 
<br/>
Strong one-on-one relationships between founders and investors help weather difficult times. Founders should feel empowered to ask questions, and investors should routinely check in with all co-founders. This two-way relationship requires emotional intelligence and egos left at the door.

</li>
<li><b>Transparent and Regular Reporting is a Must</b> 
<br/>
When things are going well, reporting often gets overlooked. But consistent, transparent updates from both sides create alignment and reduce the risk of conflict during tougher times.

</li>
<li><b>Founders Should Also Screen Investors
</b> 
<br/>
Just as investors conduct diligence, founders should assess investor alignment—values, expectations, and engagement style matter. Building with the right partner is key to long-term success.

</li>
<li><b>Education & Age Are No Longer Barriers</b> 
<br/>
The forum acknowledged that we are at an inflection point in how we value education and experience. Degrees and age are no longer accurate predictors of a founder’s ability. Authenticity, clarity of vision, and execution are far more important.

</li>
<li><b>Play to Strengths, Not Control</b> 
<br/>
Investors should support founders in areas where they can add true value rather than overstepping. The best partnerships come from complementing, not controlling.

</li>
<li><b>Leadership That Attracts Talent</b> 
<br/>
A key skill of successful founders is the ability to build strong teams—by being authentic, honest, and by hiring people smarter than themselves. A founder’s brand and values are crucial in attracting and retaining talent.

</li>
<li><b>Shared Goal: Company’s Success</b> 
<br/>
Ultimately, both founders and investors are aligned in one critical objective—the success of the company. When this shared purpose is prioritized, stronger and more resilient partnerships are built.

</li>
</ul>
 
 
 
 
 
 <br/>
The session concluded with an interactive Q&A giving attendees the freedom to ask candid questions and learn from the speakers’ journeys in a closed, trusted setting.<br/><br/>
In the lead-up to Winpe’s annual Leadership Summit & Awards 2026, we gifted exclusive WLSA giveaways to the winner of the Human Bingo - Shobha Venkataraman, Partner at Elevar Equity.<br/><br/>
The event was part of Winpe sheshines, a series of knowledge and networking events. Winpe sheshines is committed to fostering meaningful connections and bridging opportunities between women entrepreneurs and investors in the PEVC ecosystem.

 

              </div>
              <br />

              <br />
             

             
              <div className="container">
                    <div>
                      <Heading title="Gallery" />
                    </div>
                    <div className="row">
                      {this.CollegiumsImages.map((item, j) => {
                        return (
                          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" style={{padding: '8px'}}>
                            <div className="img_card">
                            <img style={{width:'100%'}} src={item.ImgSrc} alt="Winpe sheshines" />
                            <a href={item.ImgSrc1} > <i style={{color:'white', position:'absolute', left:'20px', top:'20px'}} class="fa fa-2x  fa-download "></i></a> 
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                 <br/>
  <br/> 
     <center>  
         <a href="gallery/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button">View All Images</button> </a> </center> 
       
          <br/><br/>
     
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/sheshines19June2025/index.js